import { FileText, LayoutDashboard, type LucideIcon } from 'lucide-react'

export type ConversationalQuickAction = {
  id: string
  label: string
  message: string
  icon: LucideIcon
}

function promoteTargetLabel(userData?: unknown): string {
  let promoteTarget = 'mi presencia'
  if (userData && typeof userData === 'object') {
    const t = (userData as { type?: string }).type
    if (t === 'COMPANY') promoteTarget = 'mi empresa'
    else if (t === 'PERSON') promoteTarget = 'mi perfil profesional'
  }
  return promoteTarget
}

export function getConversationalQuickActions(userData?: unknown): ConversationalQuickAction[] {
  const promoteTarget = promoteTargetLabel(userData)

  return [
    {
      id: 'analyze-docs',
      label: 'Analizar documentación de obra',
      message:
        'Quiero analizar documentación de obra y armar el borrador con el asistente, ¿cómo hago?',
      icon: FileText
    },
    {
      id: 'my-work',
      label: 'Ofrecer mis servicios/productos',
      message: `Quiero promocionar ${promoteTarget} en Edify, ¿cómo hago?`,
      icon: LayoutDashboard
    }
  ]
}
